export default __webpack_public_path__ + "static/media/logo-trustpilot-4-0-stars.c7e8a7c8.svg";